export const AUTOSAVE = 'autosave/AUTOSAVE';

export default { AUTOSAVE };
